export enum UserType {
    SUPER_ADMIN = 0,
    ADMIN = 1,
    CUSTOMER = 2,
    CONSULTANT = 3,
    SUPPLIER = 4,
  }
  